const data = {
  initialDetails: [
    {
      id: 1,
      stars: 4.9,
      speaks: "native",
      review: 2,
      imgPath: "../../img/blockuser1.png",
      icon: "../../img/flet-icon1.png",
      name: "Jane Doe",
      prof: "Community Tutor",
      language: "English",
      price: "IDR - 85,730.10",
      from: "IDR - 485,730.10",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat aliquam integer sit mauris sit. Pellentesque urna, adipiscing at aliquam tempor non. Lectus bibendum sollicitudin aliquet id...",
      workingHours: "8:00-15:00",
      holiday: "Monday",
      holidayNacional: "Sunday",
      tipo: "Native speaks",
      about:
        "I am an actor and a writer as well as an English teacher. I have appeared on TV and in short films. I love reading and watching TV and movies. One of my favorite movies is The Truman Show. I am also studying for a Masters degree in screenwriting... Read more",
    },
    {
      id: 2,
      stars: 4.5,
      speaks: "-",
      review: 2,
      imgPath: "../../img/blockuser2.png",
      icon: "../../img/flet-icon2.png",
      name: "Mary Rosamund",
      prof: "Community Tutor",
      language: "Spanish",
      price: "IDR - 85,730.10",
      from: "IDR - 485,730.10",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat aliquam integer sit mauris sit. Pellentesque urna, adipiscing at aliquam tempor non. Lectus bibendum sollicitudin aliquet id...",
      workingHours: "8:00-14:00",
      holiday: "Sunday",
      holidayNacional: "Sunday",
      tipo: "Also speaks",
      about:
        "I am an actor and a writer as well as an English teacher. I have appeared on TV and in short films. I love reading and watching TV and movies. One of my favorite movies is The Truman Show. I am also studying for a Masters degree in screenwriting... Read more",
    },
    {
      id: 3,
      stars: 5,
      review: 3,
      speaks: "native",
      imgPath: "../../img/blockuser3.png",
      icon: "../../img/flet-icon3.png",
      name: "Sherlock Watson",
      prof: "Community Tutor",
      language: "English",
      price: "IDR - 85,730.10",
      from: "IDR - 485,730.10",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat aliquam integer sit mauris sit. Pellentesque urna, adipiscing at aliquam tempor non. Lectus bibendum sollicitudin aliquet id...",
      workingHours: "8:00-18:00",
      holiday: "Monday",
      tipo: "Native speaks",
      about:
        "I am an actor and a writer as well as an English teacher. I have appeared on TV and in short films. I love reading and watching TV and movies. One of my favorite movies is The Truman Show. I am also studying for a Masters degree in screenwriting... Read more",
    },
    {
      id: 4,
      stars: 4,
      review: 3,
      speaks: "native",
      imgPath: "../../img/blockuser4.png",
      icon: "../../img/flet-icon4.png",
      name: "John Holmes",
      prof: "Community Tutor",
      language: "Spanish",
      price: "IDR - 85,730.10",
      from: "IDR - 485,730.10",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat aliquam integer sit mauris sit. Pellentesque urna, adipiscing at aliquam tempor non. Lectus bibendum sollicitudin aliquet id...",
      workingHours: "8:00-15:00",
      holiday: "Sunday",
      holidayNacional: "Sunday",
      tipo: "English",
      about:
        "I am an actor and a writer as well as an English teacher. I have appeared on TV and in short films. I love reading and watching TV and movies. One of my favorite movies is The Truman Show. I am also studying for a Masters degree in screenwriting... Read more",
    },
    {
      id: 5,
      stars: 4.1,
      speaks: "-",
      review: 5,
      imgPath: "../../img/blockuser4.png",
      icon: "../../img/flet-icon5.png",
      name: "Mycroft Lestrade",
      prof: "Community Tutor",
      language: "English",
      price: "IDR - 85,730.10",
      from: "IDR - 485,730.10",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat aliquam integer sit mauris sit. Pellentesque urna, adipiscing at aliquam tempor non. Lectus bibendum sollicitudin aliquet id...",
      workingHours: "12:00-15:00",
      holiday: "Sunday",
      holidayNacional: "Sunday",
      tipo: "Also speaks",
      about:
        "I am an actor and a writer as well as an English teacher. I have appeared on TV and in short films. I love reading and watching TV and movies. One of my favorite movies is The Truman Show. I am also studying for a Masters degree in screenwriting... Read more",
    },
  ],
  buttons: [
    {
      name: "All",
      value: "All",
    },
    {
      name: "Also speaks",
      value: "Also",
    },
    {
      name: "Native speaks",
      value: "Native",
    },
    {
      name: "English",
      value: "English",
    },
  ],
};
export default data;
